import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchTopics } from '../../apis/article.api';
import ArticleContainer from '../../components/ArticleContainer';
import TopicContainer from '../../components/TopicContainer';
import { useGetListArticleByFilter } from '../../hooks/useGetListArticleByFilter';
import GoBackButton from '../../components/GoBackButton';
import SEO from '../../components/SEO';
import { generateSEOMetadata, collectionPages } from '../../utils/seo';

const RecommendTopicsPage = () => {
  const [searchParams] = useSearchParams();
  const [topicLabels, setTopicLabels] = useState([]);
  const [currentTopicId, setCurrentTopicId] = useState(Number(searchParams.get('topicId')));

  const navigate = useNavigate();

  const getTotalTopic = (amount) => {
    return amount;
  };

  const getTopicNameById = (topicId) => {
    return topicLabels.find((data) => data.id === topicId)?.name;
  };

  const { loading, listArticle, total } = useGetListArticleByFilter({
    topic: currentTopicId
  });

  useEffect(() => {
    const fetchTopicLabels = async () => {
      try {
        const result = await fetchTopics();
        setTopicLabels(result);
      } catch (error) {
        console.log(error);
      }
    };
    fetchTopicLabels();
  }, []);

  // Generate SEO metadata for recommended topics page
  const seoMetadata = generateSEOMetadata.collectionPage(
    collectionPages['recommended-topics'].name,
    collectionPages['recommended-topics'].url,
    collectionPages['recommended-topics'].description
  );

  return (
    <div className="relative">
      <SEO {...seoMetadata} />
      <div className="max-w-[1920px] mx-auto sticky z-50 top-[68px] md:top-[80px] bg-white px-4 md:px-0 py-3 md:py-4">
        <GoBackButton
          top={'top-[100px]'}
          onClick={() => {
            navigate('/');
            window.scrollTo(0, 0);
          }}
        />
        <TopicContainer
          topicLabels={topicLabels}
          currentTopicId={currentTopicId}
          setCurrentTopicId={setCurrentTopicId}
        />
      </div>
      <div className="w-full mx-auto flex flex-start flex-col px-4 md:px-0 relative">
        <div className="flex sticky top-[128px] md:top-[149px] pt-2 md:pt-0 z-20 bg-white mx-[-16px]">
          <div className="w-full">
            <p className="text-center text-[20px] md:text-[28px] font-[800] text-growth-green-500">
              {getTopicNameById(currentTopicId)}
            </p>
            <p className="text-sm md:text-[20px] text-center font-[700] text-02-dim-gray mt-1 md:mt-2">
              {getTotalTopic(total)} Stories
            </p>
          </div>
        </div>
        <div className="max-w-[804px] w-full mx-auto flex mt-10">
          <ArticleContainer
            loading={loading}
            listArticle={listArticle || []}
            isHiddenFeaturedArticles
            isProfile
          />
        </div>
      </div>
    </div>
  );
};

export default RecommendTopicsPage;
